import { useEffect, useState } from 'react'

/** Shown when a new service worker is waiting. Reloading is the user's call. */
function UpdateToast() {
  const [worker, setWorker] = useState(null)

  useEffect(() => {
    const onUpdate = (e) => setWorker(e.detail)
    window.addEventListener('bs:update-available', onUpdate)
    return () => window.removeEventListener('bs:update-available', onUpdate)
  }, [])

  if (!worker) return null

  return (
    <div className="toast" role="status">
      <span>A newer version is ready.</span>
      <button
        type="button"
        className="btn btn--on-ink btn--sm"
        onClick={() => worker.postMessage({ type: 'SKIP_WAITING' })}
      >
        Reload
      </button>
    </div>
  )
}

export default UpdateToast
